<template>
    <nav class="w-full">
        <ul
            class="w-full app-scrollbar at1024:no-app-scrollbar flex items-start font-medium text-sm"
            :class="{
                'mt-2.5 pb-2.5': !settings.is_sourcing_mode,
            }"
        >
            <li>
                <button
                    @click="setFilter('')"
                    :class="
                        (!modelValue || modelValue === '' || modelValue === 'All')
                            ? (settings.is_dark_mode ? 'bg-white text-black' : 'bg-gray-850 text-white')
                            : 'bg-transparent type-primary hover:bg-gray-tier-6' + (settings.is_dark_mode ? ' text-white' : ' text-black')
                    "
                    class="px-3 py-1 rounded-sm"
                >
                    {{ $t("All") }}
                </button>
            </li>
            <li v-for="letter in config.alphabet">
                <button
                    :class="{
                        'bg-gray-850 text-white': modelValue === letter && !settings.is_dark_mode,
                        'bg-white text-black': modelValue === letter && settings.is_dark_mode,
                        'bg-transparent type-primary hover:bg-gray-tier-6':
                            modelValue !== letter &&
                            availableLetters.includes(letter),
                        'type-secondary': !availableLetters.includes(letter),
                    }"
                    :disabled="!availableLetters.includes(letter)"
                    class="px-3 py-1 rounded-sm disabled:!opacity-50 disabled:cursor-default"
                    @click="setFilter(letter)"
                >
                    {{ letter }}
                </button>
            </li>
        </ul>
    </nav>
</template>

<script setup>
import config from "../../config";
import { useFilterHistory } from "@/Composables";
import { useUser } from "@/Composables";

const emits = defineEmits(["update:modelValue"]);
const props = defineProps(["modelValue", "availableLetters"]);
const { settings } = useUser();
const { setFilter } = useFilterHistory();
</script>
